import { BaseSerializer } from './base.serializer'
import { HubCourseTimetable} from 'models/hub-course-timetable.model'
import { HubWeekDaySerializer } from './hub-week-day.serializer'
import { DateSerializer, TimeSerializer } from './attributes'

export class HubCourseTimetableSerializer extends BaseSerializer<HubCourseTimetable> {
  static SERIALIZABLE_ATTRIBUTES = [
    'id', 
    'hubCourseId', 
    'hoursSlot', 
    'minutesSlot', 
    'registerSmsText', 
    'registerFrom', 
    'registerTo', 
    'hubWeekDays', 
    'weekDays', // allias for hubWeekDays
    'cyclic', 
    'scheduleText',
    'ahead'
  ]

  static SERIALIZERS = {
    hubWeekDays: HubWeekDaySerializer,
    weekDays: HubWeekDaySerializer,
    registerTo: DateSerializer,
    registerFrom: DateSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    hubWeekDays: 'hubWeekDaysAttributes',
    weekDays: 'hubWeekDaysAttributes'
  }


  static DESERIALIZERS = {
    hubWeekDays: HubWeekDaySerializer,
    registerTo: TimeSerializer,
    registerFrom: TimeSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}


  static initializeObject(attributes: Object): HubCourseTimetable {
    return new HubCourseTimetable(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/hub-course-timetable.serializer.ts